<template>
  <div id="app" class="app">
    <transition name="fade">
      <div id="page" class="page" v-if="pageLoaded">
        <transition name="fade">
          <Menu
            @setAmount="setAmount"
            v-if="menuVisible"
            @scrollToSection="scrollToSection"
            :currency="currency"
            :currencyValue="currencyValue"
            :currencyCode="currencyCode"
            @changeCurrency="changeCurrency"
          />
        </transition>
        <div
          class="mob menu-icon"
          @click="toggleMenu"
          :class="{ active: menuVisible }"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <Header
          @setAmount="setAmount"
          @scrollToSection="scrollToSection"
          :currency="currency"
          :currencyValue="currencyValue"
          :currencyCode="currencyCode"
          @changeCurrency="changeCurrency"
        />
        <router-view
          @setAmount="setAmount"
          @topUp="topUp"
          @formatDate="formatDate"
          :currency="currency"
          :currencyCode="currencyCode"
          @openProductModal="openProductModal"
        />
        <!-- <Footer @goToPage="goToPage" /> -->
        <transition name="fade">
          <ProductModal
            v-if="productModalIsVisible"
            @closeProductModal="closeProductModal"
            :currency="currency"
          />
        </transition>
        <transition name="fade">
          <Login
            v-if="signInModalIsVisible"
            @closeSignInModal="closeSignInModal"
            @login2="login2"
          />
        </transition>
        <transition name="fade">
          <TopUpModal
            v-if="topUpModalIsVisible"
            :currency="currency"
            :currencyValue="currencyValue"
            @setTopUpAmount="setTopUpAmount"
          />
        </transition>
        <transition name="fade">
          <OrderModal
            v-if="orderModalIsVisible"
            :currency="currency"
            :currencyValue="currencyValue"
            @topUp="topUp"
          />
        </transition>
        <transition name="fade">
          <OrderCartModal
            @purchase="purchase"
            v-if="orderCartModalIsVisible"
            :currency="currency"
          />
        </transition>
        <transition name="fade">
          <AgeModal v-if="ageModalIsVisible" />
        </transition>
        <transition name="fade">
          <CartModal v-if="cartModalIsVisible" :currency="currency" />
        </transition>
        <transition name="fade">
          <ErrorModal v-if="errorModalIsVisible" />
        </transition>
        <transition name="fade">
          <SellModal v-if="sellModalIsVisible" />
        </transition>
        <transition name="fade">
          <ComingSoonModal
            v-if="comingSoonModalIsVisible"
            @close="closeComingSoonModal"
          />
        </transition>
        <transition name="fade">
          <WithdrawModal
            v-if="withdrawModalIsVisible && settings.payout_enabled"
            :currency="currency"
          />
        </transition>
        <transition name="fade">
          <CounterOfferModal v-if="counterOfferModalIsVisible" />
        </transition>
        <div v-if="cookesModalIsVisible" class="modal-overlay">
          <div class="cookies-modal" v-if="!settingsManagerIsVisible">
            <div class="title dark title-36">Use of Cookies</div>
            <div class="desc dark">
              This website uses cookies to operate correctly and to improve your
              browsing experience. Essential cookies are set automatically to
              support core site functions, while optional cookies may be used to
              provide enhanced features and insights. You may adjust your
              choices regarding these optional cookies at any time. For further
              details about our use of cookies, please consult our
              <a class="cookie-policy-link" @click="goToPage('cookie')"
                >Cookie Policy</a
              >.
            </div>
            <div class="buttons">
              <button class="button button-primary" @click="okGotItCookies()">
                <span>UNDERSTOOD</span>
              </button>
              <div class="buttons-row">
                <button
                  class="button button-secondary"
                  @click="rejectOptionalCookies()"
                >
                  <span>REJECT NON-ESSENTIAL COOKIES</span>
                </button>
                <button
                  class="button button-tertiary"
                  @click="settingsManagerIsVisible = true"
                >
                  <span>MANAGE COOKIES</span>
                </button>
              </div>
            </div>
          </div>
          <div v-else class="cookies-modal">
            <div class="checkbox-container">
              <label class="checkbox-label">
                <div class="checkbox-label-wrapper">
                  <input
                    type="checkbox"
                    disabled
                    v-model="cookieSettings.essential"
                  />
                  <div class="checkbox"></div>
                  <div class="title small">Essential Cookies:</div>
                  <div class="desc">
                    These cookies are strictly necessary for the Website to
                    work. They enable core features like security, log-ins, and
                    page navigation. <br />Without these cookies, some parts of
                    the Website will not function properly.
                  </div>
                </div>
              </label>
            </div>

            <div class="checkbox-container">
              <label class="checkbox-label">
                <div class="checkbox-label-wrapper">
                  <input
                    type="checkbox"
                    v-model="cookieSettings.functionality"
                  />
                  <div class="checkbox"></div>
                  <div class="title small">
                    Performance & Functional Cookies
                  </div>
                  <div class="desc">
                    Remember your preferences, such as language and login
                    details, to make the Website more convenient.
                  </div>
                </div>
              </label>
            </div>

            <div class="checkbox-container">
              <label class="checkbox-label">
                <div class="checkbox-label-wrapper">
                  <input type="checkbox" v-model="cookieSettings.analytics" />
                  <div class="checkbox"></div>
                  <div class="title small">Analytics Cookies:</div>
                  <div class="desc">
                    Collect information about how you use the Website (pages
                    visited, time spent, links clicked). This information is
                    aggregated and pseudonymised before analysis.
                  </div>
                </div>
              </label>
            </div>
            <div class="checkbox-container">
              <label class="checkbox-label">
                <div class="checkbox-label-wrapper">
                  <input type="checkbox" v-model="cookieSettings.advertising" />
                  <div class="checkbox"></div>
                  <div class="title small">
                    Marketing & Advertising Cookies:
                  </div>
                  <div class="desc">
                    Help us and our partners display relevant ads to you, track
                    the performance of ads, and limit how often you see the same
                    ad
                  </div>
                </div>
              </label>
            </div>

            <div class="buttons">
              <button class="button button-primary" @click="acceptAllCookies">
                <span>ACCEPT ALL</span>
              </button>
              <button
                @click="saveCookieSettings"
                class="button button-secondary"
              >
                <span>ACCEPT SELECTED</span>
              </button>
              <button @click="declineCookies" class="button button-tertiary">
                <span>DECLINE</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Login from './components/Login.vue'

import axios, { DEV_AUTH_TOKEN_KEY } from '@/axios'
import { loadScriptsFromString } from '@/utils/load_scripts'
import { scroller } from 'vue-scrollto/src/scrollTo'
import AgeModal from './components/AgeModal.vue'
import CartModal from './components/CartModal.vue'
import ComingSoonModal from './components/ComingSoonModal.vue'
import CounterOfferModal from './components/CounterOfferModal.vue'
import ErrorModal from './components/ErrorModal.vue'
import Header from './components/Header.vue'
import Menu from './components/Menu.vue'
import OrderCartModal from './components/OrderCartModal.vue'
import OrderModal from './components/OrderModal.vue'
import ProductModal from './components/ProductModal.vue'
import SellModal from './components/SellModal.vue'
import TopUpModal from './components/TopUpModal.vue'
import WithdrawModal from './components/WithdrawModal.vue'

export default {
  name: 'app',
  components: {
    Header,
    Menu,
    ProductModal,
    Login,
    TopUpModal,
    OrderModal,
    OrderCartModal,
    AgeModal,
    CartModal,
    ErrorModal,
    SellModal,
    WithdrawModal,
    CounterOfferModal,
    ComingSoonModal,
  },
  data: function () {
    return {
      ageModalIsVisible: false,
      pageLoaded: false,
      comingSoonModalIsVisible: false,
      heroImagesLoaded: false,
      menuVisible: false,
      isAuth: false,
      error: '',
      successMessage: '',
      orderHistory: [],
      depositHistory: [],
      textPageTitle: '',
      textPageHeader: '',
      textPageContent: '',
      imgDomain: '',
      textPageList: '',
      currency: '',
      currencyValue: '',
      currencyCode: '',
      currencyOptions: [],
      hostname: '',
      productModalIsVisible: false,
      chosenProoduct: {},
      profileData: {},
      countryOptions: [],
      amount: null,
      socials: [],
      analyticsInitialized: false,
      settings: {},
      signInModalIsVisible: false,
      topUpModalIsVisible: false,
      orderModalIsVisible: false,
      topUpAmount: '',
      ip: '',
      port: '',
      cookesModalIsVisible: false,
      faq: [
        {
          question: 'WHAT IS RADGRIND?',
          answer:
            'Radgrind is a curated Rust server focused on smooth performance, fair play, and a vibrant community. Expect balanced custom features, frequent events, and optional shop items to personalize your gameplay.',
        },
        {
          question: 'IS THE SERVER FREE?',
          answer:
            'Yes. Playing on Radgrind is completely free. The shop offers optional virtual goods for convenience or cosmetics—no purchase is required to compete.',
        },
        {
          question: "WHAT'S IN THE SHOP?",
          answer:
            'Kits, skins, and gameplay enhancements that fit our balance rules. Items are clearly labeled with what they do and how they unlock.',
        },
        {
          question: 'HOW DO I REPORT A PROBLEM OR ANOTHER PLAYER?',
          answer:
            'Email us at support@radgrind.com with details, screenshots, or clips. Our admins review every report and act quickly on rule violations.',
        },
        {
          question: 'WHO DO I CONTACT FOR SUPPORT?',
          answer:
            'For account, shop, or server questions, reach out at support@radgrind.com.',
        },
      ],
      totalSum: '0.00',
      cartContents: [],
      orderCartModalIsVisible: false,
      cartModalIsVisible: false,
      errorModalIsVisible: false,
      errorModalMessage: '',
      sellModalIsVisible: false,
      withdrawModalIsVisible: false,
      inventoryItems: [],
      sellRequestHistory: [],
      sellRequestMeta: { current_page: 1, last_page: 1, total: 0 },
      counterOfferModalIsVisible: false,
      counterOfferRequest: null,
      counterOfferError: '',
      sellRequestActionLoading: false,

      cookieSettings: {
        essential: true,
        analytics: false,
        advertising: false,
        functionality: false,
      },
      settingsManagerIsVisible: false,
    }
  },
  watch: {
    $route(to) {
      window.scrollTo(0, 0)
      this.closeMenu()
      if (this.isAuth) {
        this.getProfileData()
        this.getCartContents()
      }
      // Add class for Products page to change background
      if (
        to.name === 'Products' ||
        to.path === '/products' ||
        to.path === '/Products'
      ) {
        document.body.classList.add('products-page-active')
        document.body.classList.remove('home-page-active')
        const pageEl = document.getElementById('page')
        if (pageEl) {
          pageEl.classList.add('products-page-active')
          pageEl.classList.remove('home-page-active')
        }
      } else if (to.name === 'Home' || to.path === '/') {
        document.body.classList.add('home-page-active')
        document.body.classList.remove('products-page-active')
        const pageEl = document.getElementById('page')
        if (pageEl) {
          pageEl.classList.add('home-page-active')
          pageEl.classList.remove('products-page-active')
        }
      } else {
        document.body.classList.remove('products-page-active')
        document.body.classList.remove('home-page-active')
        const pageEl = document.getElementById('page')
        if (pageEl) {
          pageEl.classList.remove('products-page-active')
          pageEl.classList.remove('home-page-active')
        }
      }
    },
  },
  methods: {
    openComingSoonModal() {
      this.comingSoonModalIsVisible = true
    },

    closeComingSoonModal() {
      this.comingSoonModalIsVisible = false
    },

    purchase(data) {
      let self = this
      axios
        .post('cart/purchase', data)
        .then((res) => {
          if (res.data.status == 'OK') {
            if (res.data.redirect_url) {
              window.location = res.data.redirect_url
            } else {
              this.closeOrderCartModal()
              this.getOrderHistory()
              this.getCartContents()
              this.$router.push({ path: '/profile' })
            }
            this.error = ''
          } else {
            this.error = res.data.message
            setTimeout(function () {
              self.error = ''
            }, 3000)
          }
        })
        .catch((res) => {
          this.error = res.response.data.message
        })
    },
    clearCart() {
      axios
        .post('cart/clear')
        .then(() => {
          this.getCartContents()
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal()
          }
        })
    },
    removeFromCart(id) {
      let cartItem = {
        id: id,
      }

      axios
        .post('cart/remove', cartItem)
        .then(() => {
          this.getCartContents()
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal()
          }
        })
    },
    getCartContents() {
      axios
        .get('cart/contents')
        .then((res) => {
          this.cartContents = res.data.cart.payload
          this.totalSum = res.data.cart.totalAmount
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal()
          }
        })
    },
    openAgeModal() {
      this.ageModalIsVisible = true
    },
    closeAgeModal() {
      this.ageModalIsVisible = false
    },
    getFaq() {
      axios.get('faq').then((res) => {
        this.faq = res.data.payload
      })
    },
    cookiesModal() {
      const cookiesAccepted = localStorage.getItem('cookie_consent')

      if (!cookiesAccepted) {
        this.cookesModalIsVisible = true
      }
      const storedSettings = localStorage.getItem('cookie_settings')
      if (storedSettings) {
        const parsedSettings = JSON.parse(storedSettings)
        this.cookieSettings.analytics = parsedSettings.analytics || false
        this.cookieSettings.advertising = parsedSettings.advertising || false
        this.cookieSettings.functionality =
          parsedSettings.functionality || false
      }
    },
    okGotItCookies() {
      // Accept essential cookies only, close modal
      localStorage.setItem('cookie_consent', 'true')
      this.cookesModalIsVisible = false
      // Keep optional cookies as they were (default: false)
      this.saveCookieSettings()
    },
    rejectOptionalCookies() {
      // Reject optional cookies, keep essential
      localStorage.setItem('cookie_consent', 'true')
      this.cookesModalIsVisible = false
      // Disable all optional cookie types
      this.cookieSettings.analytics = false
      this.cookieSettings.advertising = false
      this.cookieSettings.functionality = false
      this.saveCookieSettings()
    },
    acceptAllCookies() {
      localStorage.setItem('cookie_consent', 'true')
      this.cookesModalIsVisible = false
      this.cookieSettings.analytics = true
      this.cookieSettings.advertising = true
      this.cookieSettings.functionality = true
      this.saveCookieSettings()
    },
    declineCookies() {
      this.cookesModalIsVisible = false
      localStorage.setItem('cookie_consent', 'false')

      // Disable all optional cookie types
      this.cookieSettings.analytics = false
      this.cookieSettings.advertising = false
      this.cookieSettings.functionality = false

      this.saveCookieSettings()
    },
    saveCookieSettings() {
      localStorage.setItem(
        'cookie_settings',
        JSON.stringify(this.cookieSettings),
      )
      this.cookesModalIsVisible = false
      localStorage.setItem('cookie_consent', 'true')
    },
    setTopUpAmount(amount) {
      this.topUpAmount = amount
      this.openOrderModal()
    },
    closeOrderModal() {
      this.orderModalIsVisible = false
    },
    closeOrderCartModal() {
      this.orderCartModalIsVisible = false
    },
    openOrderModal() {
      this.topUpModalIsVisible = false
      this.orderModalIsVisible = true
    },
    openOrderCartModal() {
      this.cartModalIsVisible = false
      this.orderCartModalIsVisible = true
    },
    closeTopUpModal() {
      this.topUpModalIsVisible = false
    },
    openTopUpModal() {
      this.orderModalIsVisible = false
      this.topUpModalIsVisible = true
    },
    openWithdrawModal() {
      this.withdrawModalIsVisible = true
    },
    closeWithdrawModal() {
      this.withdrawModalIsVisible = false
      this.getProfileData()
    },
    openSellItemsModal() {
      axios
        .get('user/inventory')
        .then((res) => {
          if (res.data.status === 'OK') {
            this.openSellModal(res.data.payload)
          } else {
            this.openErrorModal('Failed to load inventory')
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 404) {
              this.openErrorModal(
                'Please join the game server first to sell items',
              )
            } else if (err.response.status === 503) {
              this.openErrorModal(
                'Game server is currently unavailable. Please try again later',
              )
            } else if (err.response.status === 401) {
              this.openSignInModal()
            } else {
              this.openErrorModal('Failed to load inventory')
            }
          } else {
            this.openErrorModal('Failed to load inventory')
          }
        })
    },
    openErrorModal(message) {
      this.errorModalMessage = message
      this.errorModalIsVisible = true
    },
    closeErrorModal() {
      this.errorModalIsVisible = false
      this.errorModalMessage = ''
    },
    openSellModal(items) {
      this.inventoryItems = items.map((item) => ({
        ...item,
        _quantity: 0,
        _price: item.catalog_item ? item.catalog_item.price : 0,
      }))
      this.sellModalIsVisible = true
    },
    closeSellModal() {
      this.sellModalIsVisible = false
      this.inventoryItems = []
      this.getSellRequestHistory()
    },
    getSellRequestHistory(page) {
      let url = 'user/sell-requests'
      if (page) {
        url += '?page=' + page
      }
      axios
        .get(url)
        .then((res) => {
          this.sellRequestHistory = res.data.payload
          if (res.data.meta) {
            this.sellRequestMeta = res.data.meta
          }
        })
        .catch(() => {})
    },
    openCounterOfferModal(req) {
      this.counterOfferRequest = req
      this.counterOfferError = ''
      this.counterOfferModalIsVisible = true
    },
    closeCounterOfferModal() {
      this.counterOfferModalIsVisible = false
      this.counterOfferRequest = null
      this.counterOfferError = ''
    },
    approveCounterOffer() {
      if (!this.counterOfferRequest || this.sellRequestActionLoading) return
      this.sellRequestActionLoading = true
      this.counterOfferError = ''
      axios
        .post('user/sell-requests/' + this.counterOfferRequest.id + '/approve')
        .then((res) => {
          if (res.data.status === 'OK') {
            this.closeCounterOfferModal()
            this.getSellRequestHistory(this.sellRequestMeta.current_page)
            this.getProfileData()
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 401) {
              this.closeCounterOfferModal()
              this.openSignInModal()
            } else if (err.response.status === 503) {
              this.counterOfferError =
                'Game server is currently unavailable. Please try again later.'
            } else if (err.response.status === 409) {
              this.counterOfferError = 'This offer is no longer available.'
            } else if (err.response.data && err.response.data.message) {
              this.counterOfferError = err.response.data.message
            } else {
              this.counterOfferError = 'Something went wrong. Please try again.'
            }
          } else {
            this.counterOfferError =
              'Network error. Please check your connection.'
          }
        })
        .finally(() => {
          this.sellRequestActionLoading = false
        })
    },
    declineCounterOffer(id) {
      if (this.sellRequestActionLoading) return
      this.sellRequestActionLoading = true
      axios
        .post('user/sell-requests/' + id + '/decline')
        .then((res) => {
          if (res.data.status === 'OK') {
            this.closeCounterOfferModal()
            this.getSellRequestHistory(this.sellRequestMeta.current_page)
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 401) {
              this.openSignInModal()
            } else if (err.response.data && err.response.data.message) {
              this.openErrorModal(err.response.data.message)
            } else {
              this.openErrorModal('Something went wrong. Please try again.')
            }
          } else {
            this.openErrorModal('Network error. Please check your connection.')
          }
        })
        .finally(() => {
          this.sellRequestActionLoading = false
        })
    },
    login2() {
      this.error = ''
      axios
        .post('user/fake-login')
        .then((res) => {
          if (res.data.status == 'OK') {
            this.isAuth = true
          }
        })
        .catch(() => {})
    },
    closeSignInModal() {
      this.signInModalIsVisible = false
    },
    openSignInModal2() {
      this.signInModalIsVisible = true
    },
    setAmount(am) {
      this.amount = am
    },
    closeProductModal() {
      this.productModalIsVisible = false
    },
    openProductModal(product) {
      this.productModalIsVisible = true
      this.chosenProoduct = product
    },
    openCartModal() {
      this.cartModalIsVisible = true
      this.getCartContents()
    },
    closeCartModal() {
      this.cartModalIsVisible = false
    },
    scrollToSection(section) {
      if (this.$route.name != 'Home') {
        this.$router.push({ path: '/' })
      }
      setTimeout(() => {
        const firstScrollTo = scroller()
        firstScrollTo(section)
      }, 200)
    },
    getDomainName(hostName) {
      return hostName.substring(
        hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1,
      )
    },
    closeMenu() {
      this.menuVisible = false
      document.body.style.overflow = 'auto'
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible
      window.scrollTo(0, 0)
      if (this.menuVisible) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    },
    menuHeight() {
      const doc = document.documentElement
      doc.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    openSignInModal() {
      if (process.env.NODE_ENV !== 'production') {
        // Override baseURL to '/' because this route is in web.php, not api.php
        axios
          .get('/auth/test-login', {
            baseURL: '/',
          })
          .then(({ data }) => {
            if (data.status === 'ok' && data.token) {
              localStorage.setItem(DEV_AUTH_TOKEN_KEY, data.token)
              axios.defaults.headers.common.Authorization = `Bearer ${data.token}`
              this.isAuth = true
              this.closeAgeModal()
              this.getProfileData()
              this.getCartContents()
            }
          })
          .catch((error) => {
            console.error('Dev Login Failed:', error)
          })
      } else {
        // Production/Normal flow: Redirect to Steam
        window.location.replace('https://api.radgrind.com/auth/steam/redirect')
      }
    },
    logout() {
      axios
        .get('user/logout')
        .then(() => {
          if (process.env.NODE_ENV !== 'production') {
            localStorage.removeItem(DEV_AUTH_TOKEN_KEY)
            delete axios.defaults.headers.common.Authorization
          }
          this.isAuth = true
          this.$router.push({ path: '/' })
          this.isAuth = false
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal()
          }
        })
    },
    getDepositHistory() {
      axios
        .get('payments/history')
        .then((res) => {
          this.depositHistory = res.data.data
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal()
          }
        })
    },
    getOrderHistory() {
      axios
        .get('orders/history')
        .then((res) => {
          this.orderHistory = res.data.data
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal()
          }
        })
    },
    formatDate(num) {
      let objectDate = new Date(num * 1000)
      let day = objectDate.getDate()
      if (day < 10) {
        day = '0' + day
      }
      let month = objectDate.getMonth() + 1
      if (month < 10) {
        month = `0${month}`
      }
      let year = objectDate.getFullYear()

      function padTo2Digits(x) {
        return String(x).padStart(2, '0')
      }
      let hoursAndMinutes =
        padTo2Digits(objectDate.getHours()) +
        ':' +
        padTo2Digits(objectDate.getMinutes())
      let format = day + '.' + month + '.' + year + ' ' + hoursAndMinutes

      return format
    },
    openProduct(item) {
      this.$router.push({
        path: '/products/' + item.id,
        params: { data: item.id },
      })
      this.getProductPageContent(item.id)
    },
    goToPage(item) {
      let newItem
      if (item == 'privacy') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('privacy')) {
            newItem = this.textPageList[i]
          }
        }
      } else if (item == 'terms') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('terms')) {
            newItem = this.textPageList[i]
          }
        }
      } else if (item == 'cookie') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('cookie')) {
            newItem = this.textPageList[i]
          }
        }
      } else {
        newItem = item
      }

      this.$router.push({
        path: '/pages/' + newItem.slug,
        params: { data: newItem },
      })

      this.getTextPageContent(newItem.id)
    },
    getTextPageContent(id) {
      this.textPageTitle = ''
      this.textPageHeader = ''
      this.textPageContent = ''
      axios.get('static-pages/' + id).then((res) => {
        this.textPageTitle = res.data.payload.title
        this.textPageContent = res.data.payload.content
        this.textPageHeader = res.data.payload.header
      })
    },
    getTextPages() {
      axios.get('static-pages').then((res) => {
        this.textPageList = res.data.payload
      })
    },
    getSettings() {
      return axios
        .get('settings')
        .then(async (res) => {
          this.ip = res.data.payload.game_server.host
          this.port = res.data.payload.game_server.port
          this.settings = res.data.payload
          const snippet = res.data.payload.google_tag
          if (!this.analyticsInitialized && snippet) {
            await loadScriptsFromString(snippet)
            this.analyticsInitialized = true
          }
        })
        .catch(() => {})
    },
    getSocials() {
      axios
        .get('social-links')
        .then((res) => {
          this.socials = res.data.payload
        })
        .catch((res) => {
          console.log(res)
        })
    },
    topUp(data) {
      let self = this
      axios
        .post('payments/checkout', data)
        .then((res) => {
          if (res.data.status == 'OK') {
            window.location = res.data.redirect_url
          } else {
            this.error = res.data.message
            setTimeout(function () {
              self.error = ''
            }, 3000)
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal()
          } else {
            this.error = res.response.data.message
          }
        })
    },
    getProfileData() {
      let self = this
      axios
        .get('user/profile')
        .then((res) => {
          self.getOrderHistory()
          self.getDepositHistory()
          self.getSellRequestHistory()
          self.profileData = res.data.payload
        })
        .catch(() => {})
    },
    getCurrencies() {
      return axios
        .get('currencies')
        .then((res) => {
          const that = this
          this.currencyOptions = res.data.payload

          if (localStorage.getItem('currency')) {
            this.currencyCode = localStorage.getItem('currency')

            const currency = res.data.payload.find(
              ({ code }) => code === that.currencyCode,
            )

            if (currency) {
              this.currencyValue = currency.value
              this.currency = currency.symbol
            }
          } else {
            this.currencyCode = this.currencyOptions[0].code
            this.currency = this.currencyOptions[0].symbol
            this.currencyValue = this.currencyOptions[0].value
          }
        })
        .catch(() => {})
    },
    changeCurrency(item) {
      this.currencyCode = item
      this.checkCurrency()
    },
    checkCurrency() {
      const that = this
      const currency = this.currencyOptions.find(
        ({ code }) => code === that.currencyCode,
      )

      if (currency) {
        this.currency = currency.symbol
        this.currencyValue = currency.value
        console.log(currency.symbol)

        if (this.isAuth) {
          this.getProfileData()
          this.getCartContents()
        }
      }
    },
  },
  mounted: function () {
    let self = this
    this.getFaq()
    this.cookiesModal()
    this.pageLoaded = true
    setTimeout(function () {
      self.heroImagesLoaded = true
    }, 1000)
    this.hostname = this.getDomainName(window.location.hostname)
    this.currency = process.env.VUE_APP_CURRENCY
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN
    window.addEventListener('resize', self.menuHeight)
    self.getSettings()
    self.menuHeight()
    self.getTextPages()
    self.getSocials()
    self.getCurrencies()

    // Check initial route - add class after page element is created
    this.$nextTick(() => {
      if (
        this.$route.name === 'Products' ||
        this.$route.path === '/products' ||
        this.$route.path === '/Products'
      ) {
        document.body.classList.add('products-page-active')
        document.body.classList.remove('home-page-active')
        const pageEl = document.getElementById('page')
        if (pageEl) {
          pageEl.classList.add('products-page-active')
          pageEl.classList.remove('home-page-active')
        }
      } else if (this.$route.name === 'Home' || this.$route.path === '/') {
        document.body.classList.add('home-page-active')
        document.body.classList.remove('products-page-active')
        const pageEl = document.getElementById('page')
        if (pageEl) {
          pageEl.classList.add('home-page-active')
          pageEl.classList.remove('products-page-active')
        }
      }
    })

    axios
      .get('user/is-auth')
      .then((res) => {
        console.log('auth: ' + res.data.authenticated)
        self.isAuth = res.data.authenticated

        if (res.data.authenticated) {
          self.getProfileData()
          self.getCartContents()
        }
      })
      .catch(() => {})
  },
  computed: {
    minOrderAmount: function () {
      return this.settings && this.settings.min_order_amount
    },
  },
}
</script>
